module.exports = __webpack_public_path__ + "static/media/ball_1_0.85b33858.mp3";